// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__4bHrA","desc":"style_desc__1_v1D"};